import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { authLogout } from '../redux/userRelated/userSlice';
import styled from 'styled-components';

const Logout = () => {
    const currentUser = useSelector(state => state.user.currentUser);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleLogout = () => {
        dispatch(authLogout());
        navigate('/');
    };

    const handleCancel = () => {
        navigate(-1);
    };

    return (
        <LogoutContainer>
            <UserName>{currentUser.name}</UserName>
            <LogoutMessage>Are you sure you want to log out?</LogoutMessage>
            <ButtonGroup>
                <LogoutButtonLogout onClick={handleLogout}>Log Out</LogoutButtonLogout>
                <LogoutButtonCancel onClick={handleCancel}>Cancel</LogoutButtonCancel>
            </ButtonGroup>
        </LogoutContainer>
    );
};

export default Logout;

const LogoutContainer = styled.div`
  border: 2px solid #b8860b;
  border-radius: 15px;
  padding: 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.3);
  background: linear-gradient(135deg, #008080, #b8860b);
  color: white;
  text-align: center;
  max-width: 90%;
  margin: auto;
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: scale(1.02);
  }

  @media (max-width: 600px) {
    padding: 20px;
  }
`;

const UserName = styled.h1`
  font-size: 24px;
  margin-bottom: 15px;
  font-weight: bold;
`;

const LogoutMessage = styled.p`
  margin-bottom: 20px;
  font-size: 18px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  justify-content: center;
`;

const LogoutButton = styled.button`
  padding: 12px 25px;
  border-radius: 8px;
  font-size: 18px;
  color: #fff;
  cursor: pointer;
  border: none;
  font-weight: bold;
  transition: all 0.3s ease-in-out;
  text-transform: uppercase;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0px 5px 15px rgba(255, 215, 0, 0.6);
  }

  @media (max-width: 600px) {
    width: 100%;
    text-align: center;
  }
`;

const LogoutButtonLogout = styled(LogoutButton)`
  background-color: #b8860b;
  
  &:hover {
    background-color: #daa520;
  }
`;

const LogoutButtonCancel = styled(LogoutButton)`
  background-color: #008080;
  
  &:hover {
    background-color: #20b2aa;
  }
`;
